import * as ActionTypes from "../actions/actionTypes";
import { EDITOR_ITEMS } from "../../constants";

const defaultState = {};

// const stateObject = {
//   currentItemId: null,
//   currentItemType: null,
//   widgetType: null,
// };

const inspector = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.INSPECTOR_SELECT_ITEM: {
      const { id, itemType } = action;

      return {
        ...state,
        currentItemId: id,
        currentItemType: itemType
      };
    }
    case ActionTypes.MAP_ADD_PORTAL_RESPONSE:
    case ActionTypes.MAP_SELECT_WIDGET: {
      const { widget } = action.payload;
      const objState = "map_widget" in state ? state.map_widget : {};
      return {
        ...state,
        map_widget: {
          ...objState,
          currentItemId: widget,
          currentItemType: EDITOR_ITEMS.MAP_WIDGET,
          widgetType: "portal"
        }
      };
    }
    default:
      return state;
  }
};

export default inspector;



// WEBPACK FOOTER //
// ./src/redux/reducers/inspector.js